import React, { useState, useEffect } from "react";
import { Drawer } from "vaul";
import { useAppSelector } from "hooks/hooks";
import { fetchAxiosToken } from "helpers/fetchAxiosToken";
import { toast } from "components/ui/use-toast";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { ReloadIcon } from "@radix-ui/react-icons";
import { ScrollArea } from "components/ui/scroll-area";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "components/ui/alert-dialog";
import { Button } from "components/ui/button";
import { ModalLogin } from "pages/ModalLogin";
// import { LoginOrRegister } from "./LoginOrRegister";
dayjs.locale("es");

interface Props {
    drawer: typeof Drawer;
}

export interface Intervals {
    closing_time: string;
    opening_time: string;
}

const ModalReserve = ({ drawer }: Props) => {
    const infoCasaRedux = useAppSelector((state) => state.landing_house.house);

    const [loading, setLoading] = useState<boolean>(false);
    const { rol, id } = useAppSelector((state) => state.usuario_logeado);
    const [month, setMonth] = useState(dayjs().month());
    const [year, setYear] = useState(dayjs().year());
    const [startTime, setStartTime] = useState<string>();
    const [endTime, setEndTime] = useState<string>();
    const [intervals, setIntervals] = useState<Intervals[]>([]);
    const [firstOfficeId, setFirstOfficeId] = useState<string>();
    const [blockedDays, setBlockedDays] = useState<number[]>([]);
    const [blockedDates, setBlockedDates] = useState<Date[]>([]);
    const [selectedDay, setSelectedDay] = useState<string | null>(null);
    const [lodingIntervals, setLoadingIntervals] = useState<boolean>(true);
    const [modalLoginOrRegister, setModalLoginOrRegister] =
        useState<boolean>(false);
    const [reserved, setReserved] = useState(false);
    const [counter, setCounter] = useState(5);
    const handleDayClick = (day: string) => {
        setSelectedDay(day);
        getIntervals(day);
        setStartTime("");
        setEndTime("");
    };

    const getBlockedDaysAndDates = async () => {
        const dataEvent = await fetchAxiosToken({
            url: `/visitas_agendadas/getVisitasAgendadas/${infoCasaRedux.id_propietario}`,
            method: "get",
        });

        setBlockedDates(
            dataEvent.notAvailable.map((day: any) => new Date(day.start))
        );

        const schedules = dataEvent.schedules;
        const blockedDays = Object.keys(schedules).filter(
            (key) => schedules[key] === 0
        );

        setBlockedDays(blockedDays.map((day) => parseInt(day)));
    };

    const getDaysArray = () => {
        const currentDate = dayjs();
        const startOfMonth = dayjs().year(year).month(month).startOf("month");
        const endOfMonth = dayjs().year(year).month(month).endOf("month");
        const days = [];

        const startDate = currentDate.isSame(startOfMonth, "month")
            ? currentDate.date()
            : startOfMonth.date();

        for (let i = startDate; i <= endOfMonth.date(); i++) {
            const day = dayjs()
                .year(year)
                .month(month)
                .date(i)
                .format("YYYY-MM-DD");

            if (
                !blockedDates.find(
                    (blockedDate) =>
                        dayjs(blockedDate).format("YYYY-MM-DD") === day
                ) &&
                !blockedDays.includes(dayjs(day).day())
            ) {
                days.push(day);
            }
        }
        return days;
    };
    const getNextAvailableDay = (days: string[]) => {
        for (const day of days) {
            if (
                !blockedDates.find(
                    (blockedDate) =>
                        dayjs(blockedDate).format("YYYY-MM-DD") === day
                ) &&
                !blockedDays.includes(dayjs(day).day())
            ) {
                return day;
            }
        }
        return null;
    };

    const handlePrevMonth = () => {
        const newDate = dayjs().year(year).month(month).subtract(1, "month");
        const currentDate = dayjs();

        if (newDate.isBefore(currentDate, "month")) {
            return;
        }

        setMonth(newDate.month());
        setYear(newDate.year());
    };

    const handleNextMonth = () => {
        const newDate = dayjs().year(year).month(month).add(1, "month");
        setMonth(newDate.month());
        setYear(newDate.year());
    };

    const getIntervals = async (day: string) => {
        setLoadingIntervals(true);
        console.log("Fetching intervals for:", day);
        try {
            const dataInterval = await fetchAxiosToken({
                url: `/horarios_asesores/getIntervals/${infoCasaRedux.id_propietario}`,
                method: "post",
                body: {
                    date: day,
                },
            });
            console.log("dataInterval", dataInterval);
            if (day === dayjs().format("YYYY-MM-DD")) {
                const currentTime = dayjs().format("HH:mm");
                const intervalsFiltered = dataInterval.intervals.filter(
                    (interval: any) => interval.opening_time > currentTime
                );
                setIntervals(intervalsFiltered);
                setLoadingIntervals(false);
                return;
            } else {
                const intervalsFiltered = dataInterval.intervals;
                setIntervals(intervalsFiltered);
                setLoadingIntervals(false);
                return;
            }
        } catch (error: any) {
            console.log("Error fetching intervals:", error);
            // toast({
            //     variant: "destructive",
            //     title: "Error",
            //     description: <div>{error.response.}</div>,
            // });
        }
    };

    const setTimeOfTurn = (value: string) => {
        const time = intervals.find((time) => time.opening_time === value);
        if (time) {
            setStartTime(value);
            setEndTime(time.closing_time);
        }
    };

    const handleSubmit = async (idProps?: string) => {
        const userId = idProps || id;

        if (rol === "professional") {
            return;
        }

        if (startTime === "" || endTime === "") {
            toast({
                variant: "destructive",
                title: "Error",
                description: "Seleccione un horario",
            });
            return;
        }
        console.log("userId", userId);
        if (userId === "" || userId === null || userId === undefined) {
            setModalLoginOrRegister(true);
            return;
        }

        try {
            setLoading(true);
            await fetchAxiosToken({
                url: `/visitas_agendadas/createVisitaAgendada/`,
                method: "post",
                body: {
                    id_cliente: userId,
                    id_casa: infoCasaRedux.id,
                    fecha: selectedDay,
                    hora_inicio: startTime,
                    hora_final: endTime,
                    nota: "agenda por cliente",
                    scheduled_by: "Cliente",
                    estado: "Por confirmar",
                },
            });

            setReserved(true);
            setCounter(10);

            setTimeout(() => {
                setLoading(false);
            }, 2000);

            return;
        } catch (error: any) {
            toast({
                variant: "destructive",
                title: "Error",
                description: <div>{error.response.data?.message}</div>,
            });
            setLoading(false);
        }
    };

    useEffect(() => {
        getBlockedDaysAndDates();
    }, []);

    useEffect(() => {
        if (infoCasaRedux.id_propietario) {
            const days = getDaysArray();
            const nextAvailableDay = getNextAvailableDay(days);
            if (nextAvailableDay) {
                setSelectedDay(nextAvailableDay);
                getIntervals(nextAvailableDay);
            }
        }
    }, [month, year, blockedDates, blockedDays]);
    useEffect(() => {
        if (counter > 0) {
            const timer = setTimeout(() => setCounter(counter - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [counter]);

    const days = getDaysArray();
    const isCurrentMonth = dayjs().year() === year && dayjs().month() === month;

    const isMobile = window.innerWidth <= 400;

    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: isMobile ? 4 : 5,
        slidesToScroll: isMobile ? 4 : 5,
        initialSlide: 0,
        arrows: false,
    };
    return (
        <div translate="no" className="max-w-md mx-auto font-poppins-regular">
            {modalLoginOrRegister && (
                <ModalLogin
                    modalVisibleLogin={modalLoginOrRegister}
                    setModalVisibleLogin={setModalLoginOrRegister}
                />
            )}
            <div className="my-3 text-lg font-semibold text-white">
                Agendar un turno
            </div>

            <div className="grid grid-cols-1 overflow-y-auto bg-white rounded-lg shadow-xl">
                <div className="flex justify-end mt-2 mr-2">
                    <drawer.Close asChild>
                        <button
                            style={{
                                backgroundColor: "#029BFC",
                            }}
                            className="p-2 text-white rounded-full">
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1 1L14 14M1 14L14 1"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    </drawer.Close>
                </div>
                <div className="p-4">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={handlePrevMonth}
                            disabled={isCurrentMonth}
                            style={
                                isCurrentMonth
                                    ? { color: "gray", cursor: "not-allowed" }
                                    : {}
                            }>
                            <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z"
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    clipRule="evenodd"></path>
                            </svg>
                        </button>
                        <div
                            style={{
                                color: "#029BFC",
                            }}
                            className="text-lg font-semibold capitalize ">
                            {dayjs()
                                .year(year)
                                .month(month)
                                .format("MMMM YYYY")}
                        </div>
                        <button onClick={handleNextMonth}>
                            <svg
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z"
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    clipRule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                    <></>
                    <div
                        translate="no"
                        className="pl-[14px] xs400:pl-2 sm:pl-4">
                        <Slider {...settings}>
                            {days.map((day) => (
                                <DayItem
                                    key={day}
                                    day={day}
                                    onClick={handleDayClick}
                                    selected={day === selectedDay}
                                />
                            ))}
                        </Slider>
                    </div>
                </div>
                {lodingIntervals ? (
                    <div className="items-center justify-center w-full py-4">
                        <ReloadIcon
                            style={{
                                color: "#029BFC",
                            }}
                            className="w-12 h-12 mx-auto animate-spin "
                        />
                    </div>
                ) : (
                    <div className="p-4">
                        <div
                            style={{
                                color: "#029BFC",
                            }}
                            className="my-3 text-lg font-semibold ">
                            Selecciona un horario
                        </div>
                        <ScrollArea className="h-[200px]  rounded-md border p-4">
                            <div className="grid grid-cols-4 gap-2 xs550:grid-cols-5">
                                {intervals.length ? (
                                    intervals.map((interval, idx) => (
                                        <button
                                            onClick={() =>
                                                setTimeOfTurn(
                                                    interval.opening_time
                                                )
                                            }
                                            style={{
                                                backgroundColor:
                                                    startTime ===
                                                    interval.opening_time
                                                        ? "#029BFC"
                                                        : "white",
                                            }}
                                            className={`flex-shrink-0 rounded-[10px] cursor-pointer text-xs font-semibold  w-16 xs400:w-[76px] h-9 font-poppins-regular ${
                                                startTime ===
                                                interval.opening_time
                                                    ? " text-white"
                                                    : "border-[#F7F8F8] border-2 text-[#263257]"
                                            }`}
                                            key={idx}>
                                            {interval.opening_time}
                                        </button>
                                    ))
                                ) : (
                                    <div className="font-poppins-regular text-[#263257] w-full flex col-span-4 xs550:col-span-5 text-center">
                                        <p className="w-full">
                                            No hay horarios disponibles para
                                            este dia.
                                        </p>
                                    </div>
                                )}
                            </div>
                        </ScrollArea>
                        {intervals.length ? (
                            <div>
                                <div className="flex justify-center mt-2">
                                    <Button
                                        style={{
                                            backgroundColor: "#029BFC",
                                        }}
                                        className="mx-auto"
                                        disabled={
                                            loading ||
                                            !startTime ||
                                            !endTime ||
                                            rol === "professional"
                                        }
                                        onClick={() => handleSubmit()}
                                        type="submit">
                                        {loading ? (
                                            <>
                                                <ReloadIcon className="w-4 h-4 mr-2 animate-spin" />
                                                Cargando
                                            </>
                                        ) : (
                                            "Agendar visita"
                                        )}
                                    </Button>
                                </div>
                                {id === infoCasaRedux.id_propietario ? (
                                    <div className="w-full text-center">
                                        <p className="text-xs text-red-500 ">
                                            Haz la reserva para un cliente desde
                                            la
                                        </p>
                                        <a
                                            href="/dashboard-corredor/agenda"
                                            className="text-xs text-blue-500 underline">
                                            agenda
                                        </a>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
            <AlertDialog open={reserved}>
                <AlertDialogContent className="z-[999]">
                    <AlertDialogHeader>
                        <AlertDialogTitle>
                            Visita agendada correctamente
                        </AlertDialogTitle>
                        <AlertDialogDescription>
                            Al agendar una visita, el encargado recibirá una
                            notificación y al confirmar el turno, recibirás un
                            correo electrónico con la confirmación.
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <Drawer.Close disabled={counter > 0} asChild>
                            <AlertDialogAction
                                style={{
                                    backgroundColor: "#029BFC",
                                }}
                                className={` ${
                                    counter > 0
                                        ? "cursor-not-allowed"
                                        : " cursor-pointer"
                                }`}
                                disabled={counter > 0}>
                                {counter > 0 ? `Ok (${counter})` : "Ok"}
                            </AlertDialogAction>
                        </Drawer.Close>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </div>
    );
};

const DayItem = ({
    day,
    onClick,
    selected,
}: {
    day: string;
    onClick: (day: string) => void;
    selected: boolean;
}) => {
    const dayjsDay = dayjs(day);

    return (
        <button
            style={{
                backgroundColor: selected ? "#029BFC" : "white",
            }}
            className={`flex-shrink-0 rounded-[15px] cursor-pointer  w-[60px] h-16 font-poppins-regular ${
                selected ? "" : "border-[#F7F8F8] border-2"
            }`}
            onClick={() => onClick(day)}>
            <div
                className={`w-full text-sm font-bold ${
                    selected ? "text-white" : "text-[#263257]"
                }`}>
                {dayjsDay.format("DD")}
            </div>
            <div
                className={`w-full text-xs font-semibold capitalize ${
                    selected ? "text-white" : "text-[#8A96BC] "
                }`}>
                {dayjsDay.format("ddd").replace(".", "")}
            </div>
        </button>
    );
};

export default ModalReserve;
